import { cn } from '@/shared/lib/utils'

/** Beyond this the pill says "99+"; the screen reader still hears the real number. */
export const COUNT_PILL_MAX = 99

interface CountPillProps {
  /** Nothing is shown while unknown or zero: the pill only appears when there is something to do. */
  count: number | undefined
  /** The sentence a screen reader hears instead of the digits, with the real number ("3 proposals to review"). */
  label: string
  className?: string
}

/** A small violet counter (design D3: violet, because white on gold does not pass AA). */
export function CountPill({ count, label, className }: CountPillProps) {
  if (!count || count <= 0) return null
  return (
    <span
      className={cn(
        'inline-flex h-[18px] min-w-[18px] shrink-0 items-center justify-center rounded-full border border-violet-200 bg-violet-100 px-[5px] text-[11px] font-semibold leading-none text-violet-700 dark:border-violet-500/40 dark:bg-violet-950/60 dark:text-violet-300',
        className,
      )}
    >
      <span aria-hidden="true">{count > COUNT_PILL_MAX ? `${COUNT_PILL_MAX}+` : count}</span>
      <span className="sr-only">{label}</span>
    </span>
  )
}

interface CountDotProps {
  count: number | undefined
  label: string
  className?: string
}

/** The same signal without the number, where a number would not fit (a menu section, the menu button). */
export function CountDot({ count, label, className }: CountDotProps) {
  if (!count || count <= 0) return null
  return (
    <span
      role="img"
      aria-label={label}
      className={cn('inline-block h-[7px] w-[7px] shrink-0 rounded-full bg-violet-400', className)}
    />
  )
}
